var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.cmsSite)?_c('div',[_c('b-card',{staticClass:"mb-4"},[_c('h5',{staticClass:"text-primary"},[_vm._v("Game covers")]),_c('CmsGameCover')],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }